let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9RUzK")).then(() => parcelRequire('OD8to'));